<template>
  <v-snackbar
    v-model="cookieNoticeSnackbar"
    :timeout="-1"
    color="surface-light"
    location="top"
    theme="light"
    vertical
  >
    <v-row dense>
      <v-col class="text-body-2">
        We use necessary cookies to make our site work. We’d like to set
        additional cookies, including third-party cookies, to improve our
        services, understand site usage, and provide analytics and advertising.
        You can accept or reject additional cookies, or manage your preferences.
        Closing without a choice uses only necessary cookies. View our
        <a class="text-primary" href="/privacy-policy">Privacy Policy</a> for
        details.
      </v-col>
    </v-row>

    <template #actions>
      <v-btn
        class="text-none mr-2"
        color="secondary"
        variant="flat"
        @click="accept"
      >
        Accept
      </v-btn>
      <v-btn
        class="text-none mr-2"
        color="secondary"
        variant="flat"
        @click="reject"
      >
        Reject
      </v-btn>
      <v-btn
        class="text-none mr-2"
        color="secondary"
        variant="flat"
        @click="manage"
      >
        Manage
      </v-btn>
      <v-btn class="text-none" color="secondary" variant="flat" @click="close">
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
import { useConsentUIOrThrow } from '#root/lib/useConsentUI'
import { tracker } from '#root/lib/tracker'

const { cookieNoticeSnackbar, applyCookieSettings, openCookieSettings } =
  useConsentUIOrThrow()

function accept() {
  applyCookieSettings(true)
  if (tracker.posthog) {
    tracker.posthog.capture('gdpr:accept_click', {})
  }
}

function close() {
  applyCookieSettings(false)
  if (tracker.posthog) {
    tracker.posthog.capture('gdpr:close_click', {})
  }
}

function manage() {
  openCookieSettings()
  if (tracker.posthog) {
    tracker.posthog.capture('gdpr:manage_click', {})
  }
}

function reject() {
  applyCookieSettings(false)
  if (tracker.posthog) {
    tracker.posthog.capture('gdpr:reject_click', {})
  }
}
</script>
